export default "__VITE_ASSET__DSUDp9nl__"